<template lang="html">
	<core-page title="OptinMonster Onboarding Wizard">
		<div class="omapi-onboarding">
			<div class="omapi-panel">
				<header class="omapi-panel-header">
					<img src="../assets/images/logo-om.png" alt="OptinMonster Logo">
				</header>
				<wizard-screen
					v-if="wizardLoading"
					:completed="false"
					panelClass="omapi-panel__welcome"
					contentClass="omapi-text-center"
					:navPrev="false"
					:navNext="false"
				>
					<h2>Welcome to the OptinMonster Setup Wizard!</h2>
					<core-loading/>
				</wizard-screen>
				<template v-else>
					<wizard-welcome v-if="0 === step"/>
					<wizard-screen1 v-else-if="1 === step"/>
					<wizard-screen2 v-else-if="2 === step"/>
					<wizard-screen3 v-else-if="3 === step"/>
					<wizard-screen4 v-else-if="4 === step"/>
					<wizard-screen4-2 v-else-if="5 === step"/>
					<wizard-screen5 v-else/>
				</template>
			</div>
		</div>
	</core-page>
</template>

<script lang="js">
import { mapState } from 'vuex'

export default {
	name : 'onboarding-wizard',
	mounted () {
		window.addEventListener('keydown', this.maybeNav)
		this.$bus.$on('onboardingNextPage', this.nextScreen)
		this.$bus.$on('onboardingPrevPage', this.prevScreen)
	},
	beforeDestroy () {
		window.removeEventListener('keydown', this.maybeNav)
		this.$bus.$off('onboardingNextPage', this.nextScreen)
		this.$bus.$off('onboardingPrevPage', this.prevScreen)
	},
	watch : {
		step () {
			this.$store.dispatch('wizard/maybeGoBack')
		},
	},
	computed : {
		...mapState('wizard', [ 'step' ]),
		...mapState([ 'apiKey' ]),
		wizardLoading () {
			return this.apiKey && this.$store.getters.isLoading('me') && 4 > this.step
		},
	},
	methods : {
		maybeNav (evt) {
			if (evt.metaKey) {
				return
			}

			if (![
				'INPUT',
				'TEXTAREA',
				'SELECT',
			].includes(document.activeElement.nodeName)) {
				if ('ArrowRight' === evt.code) {
					this.$bus.$emit('onboardingNextPage')
				}

				if ('ArrowLeft' === evt.code) {
					this.$bus.$emit('onboardingPrevPage')
				}
			}
		},
		nextScreen () {
			const next = this.step + 1
			const proceed = {
				canProceed : 7 > next,
				current    : this.step,
				next,
			}

			this.$bus.$emit('onboardingCanNextPage', proceed)
			if (proceed.canProceed) {
				this.$store.commit('wizard/setStep', next)
			}
		},
		prevScreen () {
			const prev = this.step - 1
			const proceed = {
				canProceed : 0 <= prev,
				current    : this.step,
				prev,
			}

			this.$bus.$emit('onboardingCanPrevPage', proceed)
			if (proceed.canProceed) {
				this.$store.commit('wizard/setStep', prev)
			}
		},
	},
}
</script>

<style lang="scss">
	@import '../assets/scss/variables';
	@import '../assets/scss/pages/onboarding-wizard';
</style>
